import { render } from "./MobileBottomNav.vue?vue&type=template&id=2ec9a1dc"
import script from "./MobileBottomNav.vue?vue&type=script&lang=js"
export * from "./MobileBottomNav.vue?vue&type=script&lang=js"

import "./MobileBottomNav.vue?vue&type=style&index=0&id=2ec9a1dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__